import SuperiorCountriesActionType from 'actions/superiorCountries/superiorCountriesActionType';

const initialState = {
  superiorCountries: {},
};

const superiorCountriesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case SuperiorCountriesActionType.SAVE_SUPERIOR_COUNTRIES: {
    return {
      ...state,
      superiorCountries: {
        ...state.superiorCountries,
        [payload.key]: payload.data,
      },
    };
  }
  case SuperiorCountriesActionType.RESET_SUPERIOR_COUNTRIES:
    return {
      ...state,
      superiorCountries: {
        ...state.superiorCountries,
        [payload.key]: [],
      },
    };
  default:
    return state;
  }
};

export default superiorCountriesReducer;
